// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__sNaX8","fullmod":"BaseLayout_fullmod__4M+uO","dark":"BaseLayout_dark__km+Xv","light":"BaseLayout_light__ldtJE"};